import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PublishingService } from '../../_services/publishing.service';
import { UnivPrefsService } from '_services/univ-prefs.service';
import { MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent } from '@angular/material/card';
import { AsyncPipe } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-publish-preferences',
    templateUrl: './publish-preferences.component.html',
    styleUrls: ['./publish-preferences.component.css'],
    imports: [MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent, MatButton, AsyncPipe]
})

export class PublishPreferencesComponent {

  constructor(
    private ps: PublishingService,
    private route: ActivatedRoute,
    public ups: UnivPrefsService
  ) { }

  resetPreferences() {
    const schoolId = this.route.snapshot.parent?.paramMap.get('schoolId') ?? '';
    this.ps.copyToDraft(schoolId);
    // this.ps.copyLogoToDraft(this.schoolId);
  }
  publishPreferences() {
    const schoolId = this.route.snapshot.parent?.paramMap.get('schoolId') ?? '';
    this.ps.publishDraft(schoolId);
  }
}
